import { baseApi } from '@shared/api/baseApi';

export type ReferralClaimStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'WAITING_STOCK'
  | 'FULFILLED'
  | 'REJECTED';

export interface ReferralClaimDto {
  id: string;
  productName: string;
  status: ReferralClaimStatus;
  deliveredItems: unknown[];
  rejectionReason: string | null;
  createdAt: string;
  fulfilledAt: string | null;
}

export interface ReferralDashboardDto {
  inviteLink: string;
  target: number;
  progress: number;
  successfulReferralCount: number;
  availableRewards: number;
  canClaim: boolean;
  activeClaim: ReferralClaimDto | null;
  rewardProduct: { id: string; name: string; inStock: boolean; logoUrl: string } | null;
  referrals: {
    id: string;
    status: 'PENDING' | 'SUCCESSFUL';
    firstPurchaseQualified: boolean;
    qualifiedAt: string | null;
    createdAt: string;
    friend: { firstName: string | null; username: string | null };
  }[];
  claims: ReferralClaimDto[];
}

export const referralApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferrals: builder.query<ReferralDashboardDto, void>({
      query: () => '/referrals',
      providesTags: ['Referral'],
    }),
    claimReferralReward: builder.mutation<{ claim: ReferralClaimDto }, void>({
      query: () => ({ url: '/referrals/claim', method: 'POST' }),
      invalidatesTags: ['Referral'],
    }),
  }),
});

export const { useGetReferralsQuery, useClaimReferralRewardMutation } = referralApi;
